
        var result = require("!!../../../../../../node_modules/css-loader/index.js!./link-benefit-modal.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/products/product-detail/link-benefit-modal/link-benefit-modal.component.css
// module id = 556
// module chunks = 0